// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React, { useState } from "react";
import { Col, Row } from "antd";
import { TwitterPicker } from "react-color";
import { NewsThemeColorFormProps } from "../../../types/NewsThemeTypes";

const NewsThemeColorFormSection: React.FunctionComponent<NewsThemeColorFormProps> = (
  props: NewsThemeColorFormProps
) => {
  const { color, setColor, editMode = true } = props;

  const [displayColorPicker, setDisplayColorPicker] = useState<boolean>(false);

  const colors: string[] = [
    "#efce2f",
    "#e1cc9f",
    "#ef785c",
    "#f2928f",
    "#a3bfb5",
    "#7b97b6",
    "#b7991d",
    "#a38968",
    "#c53b2e",
    "#d15258",
    "#489379"
  ];

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  };

  const handleChangeComplete = (colorObj: any) => {
    setColor(colorObj.hex);
    setDisplayColorPicker(!displayColorPicker);
  };

  return (
    <>
      <Row>
        <Col xs={24} className="position-relative">
          <div
            className={`color-picker-custom-container ${
              !editMode ? "disabled" : ""
            } ${displayColorPicker ? "open" : ""}`}
            onClick={editMode ? handleClick : undefined}
          >
            <div
              className="color-picker-custom-color"
              style={{ backgroundColor: color }}
            />
          </div>
          {displayColorPicker && (
            <div className="color-picker-custom-popover">
              <div
                className="color-picker-custom-cover"
                onClick={handleClose}
              />
              <TwitterPicker
                onChangeComplete={handleChangeComplete}
                triangle="hide"
                width="256px"
                color={color}
                colors={colors}
              />
            </div>
          )}
        </Col>
      </Row>
    </>
  );
};

export default NewsThemeColorFormSection;
